import IconPlusLarge from '@picsart/icons/IconPlusLarge';

import { Button } from '../../core/Button/Button';
import UploadArea from '../../core/UploadArea';

import useStyles from './styles';
import IHeroFileUploader from './types';

function HeroFileUploader({
  accept,
  paragraph,
  btnLabel,
  multiple,
  className,
  children,
  disableUpload,
  childrenFooter,
  onUpload,
}: IHeroFileUploader) {
  const classes = useStyles();

  return (
    <UploadArea className={className} accept={accept} multiple={multiple} onUpload={onUpload}>
      {children}

      {paragraph && <p className={classes.paragraph}>{paragraph}</p>}

      {btnLabel && (
        <Button disabled={disableUpload}>
          <IconPlusLarge />
          {btnLabel}
        </Button>
      )}

      {childrenFooter}
    </UploadArea>
  );
}

export default HeroFileUploader;
